import { render, staticRenderFns } from "./organizationalEdit.vue?vue&type=template&id=adaf401c&scoped=true"
import script from "./organizationalEdit.vue?vue&type=script&lang=js"
export * from "./organizationalEdit.vue?vue&type=script&lang=js"
import style0 from "./organizationalEdit.vue?vue&type=style&index=0&id=adaf401c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaf401c",
  null
  
)

export default component.exports